<template>
  <div>
    <div class="banner" :style="'height:'+imgHeight+'px'">
      <ul class="banner-list">
        <li class="banner-li" style="display: list-item">
          <el-carousel trigger="click" :height="imgHeight+'px'" :interval="interval">
            <el-carousel-item v-for="(item,index) in bannerList" v-bind:key="index">
              <a :href="item.navigateParam">
                <img :src="item.iconUrl" style="width: 100%;" />
              </a>
            </el-carousel-item>
          </el-carousel>
        </li>
      </ul>
      <div class="popcontext"></div>
    </div>
    <div class="container home-container">
      <div class="search-block">
        <div class="popcontext">
          <!-- tab : 机票预订 航班动态 自助值机 军警残 -->
          <ul class="tab">
            <li
              rel="hgroup-booking"
              @click="selectPannel('li_booking')"
              class="active"
              id="li_booking"
            >
              <div
                style="
                  width: 120px;
                  height: 34px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 5px 0 0 5px;
                "
              >
                <p class="hggroup-svg">
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 32 32"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g id="首页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g
                        id="index-布局2"
                        transform="translate(-394.000000, -175.000000)"
                        style="fill: currentColor"
                        fill-rule="nonzero"
                      >
                        <g id="banner-" transform="translate(0.000000, 114.000000)">
                          <g id="ta" transform="translate(360.000000, 40.000000)">
                            <g id="L">
                              <g id="1">
                                <g id="编组-23" transform="translate(18.000000, 21.000000)">
                                  <path
                                    d="M47.8628604,2.4959235 C46.4722881,-0.463083844 40.7965403,2.1462738 35.0192937,5.86495539 C34.8630482,5.65022174 34.6716267,5.45678558 34.4176877,5.32589877 L24.4491217,0.204972852 C23.5311553,-0.267760955 22.4100953,0.105328775 21.9432455,1.03499915 C21.7772786,1.3631275 21.7499692,1.71469592 21.78118,2.05651096 L21.7753599,2.0935737 L27.3415824,11.3122509 C26.0780275,12.2770653 24.9295622,13.1832957 23.9744692,13.9528512 L22.636629,13.2673344 L18.3320107,11.5895659 L16,12.4059695 L21.1444619,17.7574902 L25.7009725,17.7574902 C28.5662517,16.3160726 32.9274714,14.007502 37.6052113,11.1130266 C46.3922787,5.68146444 48.6187932,4.10525869 47.8628604,2.4959235 Z M42.2066833,11.4899218 C41.5308879,11.9176943 40.804375,12.3746948 40.0054955,12.8708047 C42.1637366,14.2008422 43.7105544,16.4547941 44.1402775,19.0973131 L40.6598655,19.0973131 C40.5075213,16.8668652 40.0543582,14.8649016 39.4098374,13.2398971 C39.1559624,13.3981573 38.9137595,13.5486147 38.6481485,13.7126629 C38.3044148,13.9254779 37.9684837,14.1286354 37.6286194,14.3356303 C38.0407865,15.6676505 38.3122175,17.3414538 38.4020442,19.0973131 L32.5662456,19.0973131 C32.6013576,18.437155 32.6716777,17.7965036 32.7536698,17.1695709 C31.9705555,17.605146 31.2224894,18.0133159 30.505602,18.3981096 C30.4841765,18.6324459 30.4490005,18.8570289 30.4315085,19.0973131 L29.1912338,19.0973131 C27.0819193,20.2027677 25.4100028,21.0230726 24.3983403,21.5094611 C24.8592741,27.3765665 29.6443649,31.9936758 35.4919636,31.9936758 C35.5271396,31.9936758 35.560269,31.9896785 35.595509,31.9896785 C35.6208358,31.9896785 35.6481771,31.9974811 35.6755505,31.9974811 C35.7458386,31.9974811 35.8180454,31.9799571 35.8903481,31.9740411 C41.8551149,31.7573248 46.632467,26.7475871 46.632467,20.5816774 C46.632467,16.8648186 44.8902623,13.5739095 42.2066833,11.4899218 Z M26.7693643,21.2319543 L30.3787444,21.2319543 C30.4451312,24.265183 31.0779479,26.9252901 32.033041,28.8315429 C29.0974736,27.5405507 27.013454,24.6479941 26.7693643,21.2319543 Z M35.4977197,29.5600064 C33.7692657,29.5600064 32.663843,25.3823736 32.5408229,21.2319543 L38.4293856,21.2319543 C38.3083162,25.3823736 37.2262696,29.5600064 35.4977197,29.5600064 Z M39.2595399,28.6811814 C40.1169075,26.7846499 40.6598655,24.1870603 40.7184176,21.2319543 L44.2183683,21.2319543 C43.984032,24.5268927 42.0329457,27.3276399 39.2595399,28.6811814 Z"
                                    id="形状"
                                  />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </p>
                <p>机票预订</p>
              </div>
              <p class="svg-suf">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  style="fill: #d70039"
                  width="34px"
                  height="34px"
                  viewBox="0 0 40 40"
                >
                  <path
                    d="M0 0H4.60286C6.71043 0 8.66348 1.10579 9.74782 2.91303L26.5478 30.913C28.9473 34.9122 26.0666 40 21.4029 40H0V0Z"
                  />
                </svg>
              </p>
            </li>
            <!--<li rel="hgroup-cuss" id="ga_cn_ybdj"><span>预办登机</span></li>-->
            <li rel="hgroup-aoc" id="li_aoc" @click="selectPannel('li_aoc')">
              <div
                style="
                  width: 120px;
                  height: 34px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 5px 0 0 5px;
                "
              >
                <p class="hggroup-svg">
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 30 25"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <!-- Generator: Sketch 59 (86127) - https://sketch.com -->
                    <title>形状</title>
                    <desc>Created with Sketch.</desc>
                    <g id="首页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g
                        id="index-red"
                        transform="translate(-396.000000, -279.000000)"
                        style="fill: currentColor"
                        fill-rule="nonzero"
                      >
                        <g id="banner-" transform="translate(0.000000, 114.000000)">
                          <g id="ta" transform="translate(360.000000, 40.000000)">
                            <g id="L">
                              <g id="2" transform="translate(0.000000, 100.000000)">
                                <g id="编组-25" transform="translate(18.000000, 25.000000)">
                                  <path
                                    d="M27.606906,0.942313887 C27.606906,0.703130966 27.7046493,0.458913841 27.9047671,0.273455468 C28.1050058,0.0928298642 28.3687554,-1.77635684e-15 28.6322232,-1.77635684e-15 L37.3357595,-1.77635684e-15 C37.5970122,-1.77635684e-15 37.8607618,0.092789609 38.0608797,0.273455468 C38.2611587,0.458873586 38.3636944,0.703090671 38.3636944,0.942313887 L38.3636944,8.93059704 L27.606906,8.93059704 L27.606906,0.942313887 Z M39.9749876,24.6335468 C39.7308108,24.8777236 39.3598537,24.9998322 38.8568003,24.9998322 L37.6701887,24.9998322 L35.5657897,24.9998322 L32.933972,24.9998322 L30.2680025,24.9998322 L28.0658602,24.9998322 L26.8500103,24.9998322 C26.5424433,24.9998322 26.3056768,24.9558135 26.1420868,24.8777236 C25.9759596,24.7947607 25.8734238,24.6872713 25.8295662,24.5554569 C25.7855476,24.4236425 25.775882,24.2771686 25.7952937,24.1160756 C25.8173232,23.954902 25.8490182,23.803555 25.8930369,23.662075 C25.9368945,23.5203131 26.0198977,23.266511 26.1420868,22.9002659 C26.2640745,22.5389744 26.376437,22.1630234 26.4887188,21.7771653 C26.6181974,21.3328304 26.7718802,20.8445975 26.947673,20.3221324 L39.0521257,20.3221324 C39.1839401,20.7274023 39.3061694,21.1230469 39.4134574,21.50375 C39.5258198,21.8504626 39.6283556,22.1971349 39.7259377,22.5535936 C39.826057,22.9051389 39.93113,23.2176192 40.0384583,23.4812078 C40.2386567,24.0036729 40.2142511,24.3894908 39.9749876,24.6335468 Z M48,19.1453073 C48,19.2870692 48,19.4236358 48,19.5605247 C48,19.5848497 48,19.6140881 48,19.6385743 L48,21.5964592 C48,21.835763 47.8998001,22.0749862 47.6995614,22.2605654 C47.4993226,22.4461043 47.2356939,22.5388939 46.9720651,22.5388939 L44.677093,22.5388938 C44.3694857,22.5583623 44.0472593,22.5632189 43.7079168,22.5535533 C43.3685742,22.5436461 43.0438509,22.5388938 42.7387406,22.5388938 L41.6839837,22.5388938 L40.2045855,18.6521208 L25.7636389,18.6521208 L24.315976,22.5388938 L23.3637951,22.5388938 L22.243272,22.5388938 C21.8696972,22.5388938 21.4374845,22.5388938 20.9589978,22.5388938 L19.0278946,22.5388938 C18.7641853,22.5388938 18.500637,22.4461042 18.3003983,22.2605653 C18.1001194,22.0749861 18.0000403,21.8357629 18.0000403,21.5917069 L18.0000403,19.1942795 L18.0000403,14.6386078 L47.9681035,14.6386078 L47.9681035,16.220582 C47.9681035,16.6843689 47.9730169,17.2117071 47.982763,17.7976831 C47.99263,18.2468106 47.997342,18.6911858 48,19.1404744 L48,19.1453073 L48,19.1453073 Z M47.9999597,11.7527865 L47.9999597,12.9979554 L18,12.9979554 L18,10.9080547 L18,10.6883238 L18,8.53495248 C18,8.29580981 18.1000791,8.05155243 18.300358,7.87088657 C18.500637,7.68546846 18.7641853,7.59267885 19.0278543,7.59267885 L21.3227862,7.59267885 L22.2602673,7.59267885 L24.052186,7.59267885 C24.6234623,7.59267885 25.2045653,7.58277162 25.7952936,7.56331962 L25.7952936,10.5076579 L40.2044646,10.5076579 L40.2044646,7.56331962 L44.3791915,7.56331962 L44.5794705,7.56331962 L46.9719442,7.56331962 C47.2356535,7.56331962 47.4992824,7.65610923 47.6994405,7.83677509 C47.8996792,8.02235431 47.9999597,8.26645059 47.9999597,8.50575435 L47.9999597,11.5183559 C47.9999597,11.5965665 47.9999597,11.6746564 47.9999597,11.7527865 Z"
                                    id="形状"
                                  />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </p>
                <p>航班动态</p>
              </div>
              <p class="svg-suf">
                <svg style="fill: #d70039" width="34px" height="34px" viewBox="0 0 40 40">
                  <path
                    d="M0 0H4.60286C6.71043 0 8.66348 1.10579 9.74782 2.91303L26.5478 30.913C28.9473 34.9122 26.0666 40 21.4029 40H0V0Z"
                  />
                </svg>
              </p>
            </li>
            <li rel="hgroup-order" id="li_jjbooking" style="width:240px;" @click="selectPannel('li_jjbooking')">
              <div
                style="
                  width: 180px;
                  height: 34px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-radius: 5px 0 0 5px;
                "
              >
                <p class="hggroup-svg">
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 33 31"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <!-- Generator: Sketch 59 (86127) - https://sketch.com -->
                    <title>形状</title>
                    <desc>Created with Sketch.</desc>
                    <g id="首页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g
                        id="index-red"
                        transform="translate(-394.000000, -478.000000)"
                        style="fill: currentColor"
                        fill-rule="nonzero"
                      >
                        <g id="banner-" transform="translate(0.000000, 114.000000)">
                          <g id="ta" transform="translate(360.000000, 40.000000)">
                            <g id="L">
                              <g id="4" transform="translate(8.000000, 323.000000)">
                                <path
                                  d="M43.9926834,1.58348323 C44.2646226,1.77919096 44.5011257,2.01992173 44.691985,2.29528544 L48.787789,8.20442028 C48.9886393,8.49420979 49.2869175,8.70219553 49.6282744,8.79048058 L56.1050863,10.4663042 C57.0495595,10.7105907 57.8114604,11.4072688 58.1390707,12.3261686 C58.466681,13.2450685 58.3173697,14.2666161 57.7404666,15.0533105 L53.3997967,20.9712694 C53.2112192,21.2284398 53.1113435,21.5399384 53.1152229,21.8588162 L53.1961095,28.3988666 C53.2078271,29.3416346 52.7668828,30.232878 52.0103457,30.7955506 C51.2538086,31.3582233 50.2733873,31.5241171 49.3738493,31.2416635 L42.7543829,29.1628775 C42.4711942,29.0738078 42.1676796,29.072526 41.8837488,29.1592008 L34.8936746,31.2960781 C34.0019073,31.5688495 33.033621,31.4025717 32.2839411,30.8479246 C31.5342613,30.2932776 31.0920182,29.4159819 31.0920037,28.4834299 L31.0920037,21.8139609 C31.092142,21.52288 31.0058992,21.2383045 30.8441965,20.9962707 L26.8064838,14.9613939 C26.2795382,14.1736597 26.1644434,13.1802797 26.4973104,12.2929261 C26.8301774,11.4055724 27.5702193,10.732974 28.4852487,10.4861581 L34.777492,8.78974524 C35.1040977,8.70149916 35.3902912,8.50334526 35.5878288,8.22868628 L39.88732,2.25337146 C40.836003,0.934726569 42.6740329,0.634808035 43.9926834,1.58348323 Z M47.1399081,17.7534528 C45.9942595,19.05058 44.4463838,19.6947316 42.3823045,19.6947315 C40.2991065,19.6947315 38.6497549,19.0344026 37.3430684,17.6983028 C36.7730211,17.1303899 35.8524007,17.1260448 35.2770182,17.6885517 C34.7016356,18.2510585 34.6851478,19.1715415 35.2400164,19.7542935 C37.1136445,21.670571 39.5248009,22.6367983 42.3830398,22.6367983 C45.2611326,22.6367983 47.6186097,21.6543936 49.344436,19.6991436 C49.8649412,19.0884488 49.7998468,18.1732486 49.1981462,17.6423718 C48.5964457,17.1114949 47.6802657,17.1609226 47.1391727,17.7534528 L47.1399081,17.7534528 Z"
                                  id="形状"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </p>
                <p>伤残军警优惠订票入口</p>
              </div>
              <p class="svg-suf">
                <svg style="fill: #d70039" width="34px" height="34px" viewBox="0 0 40 40">
                  <path
                    d="M0 0H4.60286C6.71043 0 8.66348 1.10579 9.74782 2.91303L26.5478 30.913C28.9473 34.9122 26.0666 40 21.4029 40H0V0Z"
                  />
                </svg>
              </p>
            </li>
          </ul>
          <!-- 筛选条件 -->
          <hgroup id="hgroup-booking" style="display: block">
            <div class="panel-header">
              <el-row v-if="bookingtabstatus">
                <el-col style="display: flex">
                  <el-select
                    v-model="searchfilter.tripType"
                    @change="changeTab($event)"
                    placeholder
                    style="width: 100px; margin-left: 10px"
                  >
                    <el-option
                      v-for="item in tripTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-col>
                    <FilterPanel @changePassNum="changePassNum" />
                  </el-col>
                </el-col>
              </el-row>
              <el-row v-if="dynamictabstatus">
                <el-col style="display: flex">
                  <el-select
                    v-model="dynamicFilter.dynamicType"
                    @change="changeDynamicTab($event)"
                    placeholder
                    style="width: 100px; margin-left: 10px"
                  >
                    <el-option
                      v-for="item in dynamicTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row v-if="checkintabstatus">
                <el-col style="display: flex">
                  <el-select
                    v-model="checkInFilter.checkinType"
                    @change="changeCheckInTab($event)"
                    placeholder
                    style="width: 100px; margin-left: 10px"
                  >
                    <el-option
                      v-for="item in checkinTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
            <!--  自助值机 -->
            <article v-if="checkintabstatus" class="header-filter">
              <div>
                <div class="pannel-body">
                  <el-row style="width: 70%">
                    <el-col v-if="checkInByID" :span="6">
                      <div class="filter">
                        <p class="filter-title">证件号</p>
                        <div class="filter-input">
                          <el-input
                            placeholder="请输入证件号"
                            v-model="checkInFilter.certNo"
                            ref="certNo"
                            autocomplete="on"
                            clearable
                          ></el-input>
                        </div>
                      </div>
                    </el-col>
                    <el-col v-if="checkInByTN" :span="6">
                      <div class="filter">
                        <p class="filter-title">票号</p>
                        <div class="filter-input">
                          <el-input
                            placeholder="请输入票号"
                            v-model="checkInFilter.tktNo"
                            ref="tktNo"
                            clearable
                          ></el-input>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="filter">
                        <p class="filter-title">姓&nbsp;名</p>
                        <div class="filter-input">
                          <el-input
                            placeholder="请输入姓名"
                            v-model="checkInFilter.passName"
                            ref="passName"
                            clearable
                          ></el-input>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="filter">
                        <p class="filter-title">手机号</p>
                        <div class="filter-input">
                          <el-input
                            placeholder="请输入手机号"
                            v-model="checkInFilter.passTel"
                            ref="passTel"
                            clearable
                          ></el-input>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" style="display: flex; align-items: center">
                    <el-checkbox
                          v-model="checkInFilter.checked"
                          style="color: #d6003a; margin-right: 5px"
                        >同意</el-checkbox>
                      <p class="filter-title">
                        <a
                          v-for="(value,key) in orderNeedKnows"
                          :key="key"
                          class="link link-sm"
                          target="_blank"
                          @click="$refs.aliasdialog.showDialog(key, value)"
                        >{{value}}</a>
                      </p>
                    </el-col>
                  </el-row>
                  <el-button type="danger" class="indexbtn" @click="checkInHandler">查&nbsp;询</el-button>
                </div>
              </div>
            </article>
            <!-- 航班动态 -->
            <article v-if="dynamictabstatus" class="header-filter">
              <div>
                <div class="pannel-body" v-if="dynamictab_flightno">
                  <el-row>
                    <el-col :span="20">
                      <div class="filter">
                        <p class="filter-title">航班号</p>
                        <div class="filter-input">
                          <el-input placeholder="请输入航班号" v-model="dynamicFilter.flightNo" clearable></el-input>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="filter-line"></el-row>
                  <el-row>
                    <el-col :span="20">
                      <div class="filter">
                        <p class="filter-title">出发日期</p>
                        <div class="filter-input">
                          <el-date-picker
                            v-model="dynamicFilter.deptDate"
                            :picker-options="expireTimeOption"
                            value-format="yyyy-MM-dd"
                            style="width: 100%"
                          ></el-date-picker>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-button type="danger" class="indexbtn" @click="gotoSearchDynamic">查&nbsp;询</el-button>
                </div>
                <div class="pannel-body" v-if="dynamictab_airport">
                  <el-row>
                    <el-col :span="10">
                      <div class="filter">
                        <p class="filter-title">出发城市</p>
                        <div class="filter-input">
                          <el-autocomplete
                            class="inline-input"
                            style="margin-top: 10px"
                            v-model="dynamicFilter.deptAirport"
                            clearable
                            :fetch-suggestions="querySearchDynamic"
                            @select="handleSelectDynamic('dept', $event)"
                            @blur="handleSearchOnblur(dynamicFilter, $refs.arrAirportPannelDynamic,'dept', $event)"
                            placeholder="出发机场"
                          >
                            <template slot-scope="{ item }">
                              <div class="name">{{ item.cityName }}</div>
                              <!-- <div class="name">{{ item.chineseName }}</div> -->
                            </template>
                          </el-autocomplete>
                          <AirportPannel
                            ref="deptAirportPannelDynamic"
                            @selected="handleSelectDynamic('dept', $event)"
                          ></AirportPannel>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <i class="el-icon-sort separet" @click="changeDynamicAirports"></i>
                    </el-col>
                    <el-col :span="10">
                      <div class="filter">
                        <p class="filter-title">到达城市</p>
                        <div class="filter-input">
                          <el-autocomplete
                            class="inline-input"
                            style="margin-top: 10px"
                            v-model="dynamicFilter.arrAirport"
                            clearable
                            :fetch-suggestions="querySearchDynamic2"
                            placeholder="到达机场"
                            @select="handleSelectDynamic('arr', $event)"
                            @blur="handleSearchOnblur(dynamicFilter, $refs.arrAirportPannelDynamic,'arr', $event)"
                          >
                            <template slot-scope="{ item }">
                              <div class="name">{{ item.cityName }}</div>
                              <!-- <div class="name">{{ item.chineseName }}</div> -->
                            </template>
                          </el-autocomplete>
                          <AirportPannel
                            ref="arrAirportPannelDynamic"
                            @selected="handleSelectDynamic('arr', $event)"
                          ></AirportPannel>
                        </div>
                      </div>
                    </el-col>
                    <el-col></el-col>
                  </el-row>
                  <el-row class="filter-line"></el-row>
                  <el-row>
                    <el-col :span="20">
                      <div class="filter">
                        <p class="filter-title">出发日期</p>
                        <div class="filter-input">
                          <el-date-picker
                            v-model="dynamicFilter.deptDate"
                            :picker-options="expireTimeOption"
                            value-format="yyyy-MM-dd"
                            style="width: 100%"
                          ></el-date-picker>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-button type="danger" class="indexbtn" @click="gotoSearchDynamic">查&nbsp;询</el-button>
                </div>
              </div>
            </article>
            <!-- 机票预订 -->
            <article v-if="bookingtabstatus" class="header-filter">
              <div>
                <div class="pannel-body">
                  <el-row>
                    <el-col :span="10">
                      <div class="filter">
                        <p class="filter-title">出发城市</p>
                        <div class="filter-input">
                          <el-autocomplete
                            class="inline-input"
                            style="margin-top: 10px"
                            v-model="searchfilter.deptAirport"
                            clearable
                            :select-when-unmatched="true"
                            :fetch-suggestions="querySearch"
                            @select="handleSelect('dept', $event)"
                            @change="handleChange('dept',$event)"
                            @blur="handleSearchOnblur(searchfilter, $refs.deptAirportPannel,'dept', $event)"
                            placeholder="出发城市"
                          >
                            <template slot-scope="{ item }">
                              <div class="name">{{ item.cityName }}</div>
                              <!-- <div class="name">{{ item.chineseName }}</div> -->
                            </template>
                          </el-autocomplete>
                          <AirportPannel
                            ref="deptAirportPannel"
                            @selected="handleSelect('dept', $event)"
                          ></AirportPannel>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <i class="el-icon-sort separet" @click="changeFlightsAirports"></i>
                    </el-col>
                    <el-col :span="10">
                      <div class="filter">
                        <p class="filter-title">到达城市</p>
                        <div class="filter-input">
                          <el-autocomplete
                            class="inline-input"
                            style="margin-top: 10px"
                            v-model="searchfilter.arrAirport"
                            clearable
                            :fetch-suggestions="querySearch2"
                            @select="handleSelect('arr', $event)"
                            @blur="handleSearchOnblur(searchfilter, $refs.arrAirportPannel,'arr', $event)"
                            placeholder="到达城市"
                          >
                            <template slot-scope="{ item }">
                              <div class="name">{{ item.cityName }}</div>
                              <!-- <div class="name">{{ item.chineseName }}</div> -->
                            </template>
                          </el-autocomplete>
                          <AirportPannel
                            ref="arrAirportPannel"
                            @selected="handleSelect('arr', $event)"
                          ></AirportPannel>
                        </div>
                      </div>
                    </el-col>
                    <el-col></el-col>
                  </el-row>
                  <el-row class="filter-line"></el-row>
                  <el-row>
                    <el-col :span="10">
                      <div class="filter">
                        <p class="filter-title">出发日期</p>
                        <div class="filter-input">
                          <el-date-picker
                            v-model="searchfilter.deptDate"
                            :picker-options="expireTimeOption"
                            value-format="yyyy-MM-dd"
                            style="width: 200px"
                          ></el-date-picker>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <i class style="width: 100%">&nbsp;ㅤ</i>
                    </el-col>
                    <el-col :span="10" v-if="searchfilter.tripType == 'RT'">
                      <div class="filter">
                        <p class="filter-title">返程日期</p>
                        <div class="filter-input">
                          <el-date-picker
                            v-model="searchfilter.retDate"
                            value-format="yyyy-MM-dd"
                            style="width: 100%"
                          ></el-date-picker>
                        </div>
                      </div>
                    </el-col>
                    <el-col></el-col>
                  </el-row>
                  <el-button type="danger" class="indexbtn" @click="gotoSearchFlgihts">查&nbsp;询</el-button>
                </div>
              </div>
            </article>
          </hgroup>
          <div class="index-notice" v-if="scrollNewsShow">
            <div class="notice-scroll">
              <div class="notice-title">
                <p style="border-radius: 5px 0 0 5px;padding-left:10px">
                  <svg
                    class="icon"
                    style="
                      width: 2em;
                      height: 2em;
                      vertical-align: middle;
                      fill: currentColor;
                      overflow: hidden;
                    "
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2430"
                  >
                    <path
                      d="M599.104 243.434667V789.546667c0 43.626667-53.866667 64.789333-84.053333 33.024l-140.309334-128.085334H203.392a64 64 0 0 1-64-64V416.981333a64 64 0 0 1 60.224-63.893333l4.309333-0.106667 172.970667 2.88 138.176-145.450666c30.165333-31.786667 84.053333-10.602667 84.053333 33.024z m127.68 12.309333c92.544 47.082667 158.229333 139.392 167.957333 247.829333v56.021334c-9.450667 105.472-71.850667 195.690667-160.426666 243.882666L704.789333 746.666667A245.269333 245.269333 0 0 0 832 531.584a245.333333 245.333333 0 0 0-134.698667-219.029333l29.482667-56.810667z m-191.68 26.496l-131.157333 138.090667-200.554667-3.349334v213.482667h196.16l135.552 123.733333V282.24z m137.770667 77.418667a191.466667 191.466667 0 0 1 94.442666 165.418666 191.466667 191.466667 0 0 1-92.416 164.202667l-29.653333-56.96a127.488 127.488 0 0 0 58.069333-107.242667 127.488 127.488 0 0 0-60.010666-108.501333l29.568-56.917333z"
                      p-id="2431"
                    />
                  </svg>
                </p>
                <p>新闻公告</p>
                <svg style="fill: #d70039" width="36px" height="36px" viewBox="0 0 40 40">
                  <path
                    d="M0 0H4.60286C6.71043 0 8.66348 1.10579 9.74782 2.91303L26.5478 30.913C28.9473 34.9122 26.0666 40 21.4029 40H0V0Z"
                  />
                </svg>
              </div>
              <div class="swiper-parent" id="news-swiper">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="item in newsitems"
                      v-bind:key="item.id"
                      style="height:60px"
                    >
                      <a
                        :href="'/doc/detail/' + item.id"
                        style="padding-left: 10px"
                      >{{ item.newsTitle }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div style="height: 24px; cursor: pointer">
                <a href="/company/news" class="link-more">更多</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="recommend container-module">
        <el-row :gutter="20">
          <el-col style="width: 100%">
            <div style="background-color: #ffffff">
              <div class="main-title">推荐航线</div>
              <div class="sub-title">为您提供实惠的价格</div>
              <div class="title" style="padding-bottom: 5px">
                <ul class="discount-city">
                  <li
                    @click="changeHot(item)"
                    :class="
                      item.airportCode == activeHotAirport.airportCode
                        ? 'active'
                        : ''
                    "
                    v-for="item in hotAirports"
                    v-bind:key="item.airportCode"
                  >{{ item.airportName }}</li>
                </ul>
              </div>
              <div class="commend list" style="height: 220px; clear: both">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <div class="commendlist">
                      <ul>
                        <li
                          v-for="(item, index) in lowestFlightsData.slice(0, 4)"
                          v-bind:key="index"
                        >
                          <a href="javascript:void(0)" @click="gotoHotline(item)" type="SEARCH">
                            <dl>
                              <dd>
                                {{ item.depAirportName }}
                                <span></span>
                              </dd>
                              <dd class="center">
                                <img
                                  src="https://static.a6air.com/pc/common/fly-to.png"
                                  width="25px"
                                  height="25px"
                                />
                              </dd>
                            </dl>
                            <dl>
                              <dd class="to-address" style="max-width: 250px">
                                {{ item.arrAirportName }}
                                <span></span>
                              </dd>
                            </dl>
                            <dl>
                              <dt style="line-height: 27px">{{ item.flightDate }}</dt>
                            </dl>
                            <em>
                              <div class="e1">￥</div>
                              <div class="e2">{{ item.amount | mathInt }}</div>
                              <div class="e3">起</div>
                            </em>
                          </a>
                          <!-- <div class="commend-item-bottom"></div> -->
                        </li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="product container-module" style="margin-top: 0">
        <div class="main-title">旅行产品</div>
        <div class="sub-title">为您提供优质的旅行服务</div>
        <div class="product-content">
          <div v-for="item in travelProducts" :key="item.id" class="product-item">
            <a :href="'/doc/product/' + item.id">
              <img class="product-img" :src="item.coverPic" />
            </a>
            <div class="info">
              <p style="font-weight: 600; font-size: 16px">{{ item.newsTitle }}</p>
              <span v-html="item.newsDesc"></span>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻公告 -->
      <div class="block_item_parent container-module" style="margin-top: 0">
        <div class="main-title">新闻公告</div>
        <div class="sub-title">为您提供新鲜的资讯</div>
        <div style="float: right">
          <div
            style="
              width: 16px;
              height: 16px;
              background: rgba(255, 255, 255, 1);
              border-radius: 10px;
              line-height: 40px;
              margin-left: 5px;
              float: right;
              text-align: center;
            "
          >
            <!-- <img src="../../assets/arrow-right.png"> -->
          </div>
          <div
            style="
              line-height: 40px;

              font-size: 12px;
              float: right;
            "
          >
            <a style="color: #d60039" href="/company/news">查看更多</a>
          </div>
        </div>
      </div>
      <div class="news-block container-module" style="clear: both; margin-top: 10px">
        <el-row>
          <el-col :span="14">
            <div>
              <div id="certify">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item,index) in newsCoverPics"
                      v-bind:key="index"
                    >
                      <a :href="'/doc/detail/' + item.id">
                        <img :src="item.coverPic" alt />
                      </a>
                    </div>
                    <!-- <div
                      class="swiper-slide"
                      v-for="(item,index) in newsPicList"
                      v-bind:key="index"
                    >
                      <a :href="'#/doc/detail/' + item.id">
                        <img style="width: 400px;height: 240px;" :src="item.iconUrl" alt />
                      </a>
                    </div> -->
                  </div>
                </div>
                <div class="swiper-pagination" style="display: none"></div>
                <div class="swiper-button-prev" style="display: none"></div>
                <div class="swiper-button-next" style="display: none"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="news-block-body">
              <ul style="margin-top: 0px; min-height: 245px; margin-left: 20px">
                <li v-for="item in newsitems" v-bind:key="item.id" style="padding-left: 10px">
                  <a :href="'/doc/detail/' + item.id">
                    <span>{{ item.newsTitle }}</span>
                    <br />
                    <span class="news-date">{{ item.modifyAt | fromNow }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
      <aliasViewDialog ref="aliasdialog"></aliasViewDialog>
      <div class="active-block" style="clear: both; height: 15px"></div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
const Swiper = window.Swiper;
import aliasViewDialog from "../../components/AliasViewDialog";
import {
  getNewsTopN,
  getNewsPicTopN,
  getAdList,
  getAdListByManage,
  fetchAirports,
  getLowestFlights,
  getHotAirlines,
  queryNoticeList,
  queryDict
} from "@/api/newsapi";
import FilterPanel from "../../components/FilterPanel";
import AirportPannel from "../../components/AirportPannel";
export default {
  components: { aliasViewDialog, FilterPanel, AirportPannel },
  data() {
    return {
      input: "",
      scrollNewsShow: true,
      checkInByID: true,
      checkInByTN: false,
      dynamictab_airport: true,
      dynamictab_flightno: false,
      bookingtabstatus: true,
      dynamictabstatus: false,
      checkintabstatus: false,
      tripType: "OW",
      dynamicType: "AIRPORT",
      checkInType: "ID",
      interval: 4000,
      searchfilter: {
        deptAirport: "长沙",
        deptAirportCode: "CSX",
        arrAirport: "昆明",
        arrAirportCode: "KMG",
        deptDate: moment()
          .add(1, "days")
          .format("YYYY-MM-DD"),
        retDate: moment()
          .add(8, "days")
          .format("YYYY-MM-DD"),
        tripType: "OW",
        passType: "ADT",
        passADT: "",
        passCHD: "",
        passINF: "",
        passJING: "",
        passJUN: ""
      },
      dynamicFilter: {
        dynamicType: "AIRPORT",
        deptAirport: "",
        deptAirportCode: "",
        arrAirport: "",
        arrAirportCode: "",
        deptDate: "",
        flightNo: ""
      },
      checkInFilter: {
        checkinType: "ID",
        certNo: "",
        tktNo: "",
        passName: "",
        passTel: ""
      },
      airports: [],
      normalBooking: true,
      state1: "",
      hotAirports: [],
      hotAirlines: {},
      activeHotAirport: {},
      newsitems: [],
      newsCoverPics: [], // 新闻图片
      passengerServiceNewsItems: [],
      defaultAirport: {},
      travelProducts: [],
      bannerList: [],
      newsPicList: [],
      restaurants: [],
      lowestFlightsData: [],
      tripTypeOptions: [
        {
          value: "OW",
          label: "单程"
        },
        {
          value: "RT",
          label: "往返"
        }
      ], // 单程往返
      dynamicTypeOptions: [
        {
          value: "AIRPORT",
          label: "按出发到达"
        },
        {
          value: "FLIGHTNO",
          label: "航班号"
        }
      ],
      checkinTypeOptions: [
        {
          value: "ID",
          label: "身份证号"
        },
        {
          value: "TN",
          label: "票号"
        }
      ],
      // passTypeOptions:[],
      passTypeOptions: [
        // 旅客类型
        {
          value: "ADT",
          label: "成人"
        },
        {
          value: "CHD",
          label: "儿童"
        },
        {
          value: "INF",
          label: "婴儿"
        }
      ],
      value: "",
      fromFilterShow: false,
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      screenWidth: document.body.clientWidth,
      imgHeight: '550', // 默认高度550
      orderNeedKnows:[]
    };
  },
  filters: {
    fromNow(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    mathInt(amount) {
      return Math.floor(amount);
    },
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 15) {
        return value.slice(0, 15) + "...";
      }
      return value;
    }
  },
  mounted: function() {
    this.loadBanner();
    this.loadNews();
    this.restaurants = this.getAirports();
    this.loadHotAirlines();
    this._queryOrderNeedKnowDictKeys()
    // this.$refs.table.loadData()
    const that = this
    window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
        })()
    }
    this.getDicConfigByKey('INDEX_DEFAULT_OD')
  },
  watch:{
      screenWidth(val){
          if(!this.timer){
              this.screenWidth = val
              this.timer = true
              let that = this
              setTimeout(function(){
                  console.log(that.screenWidth)
                  /* 兼容小屏图片尺寸不变 */
                  if(that.screenWidth < 1440){
                    that.imgHeight = 450
                  }else{
                    that.imgHeight = 550
                  }
                  that.timer = false
              },400)
          }
      }
  },
  methods: {
    changeDynamicAirports() {
      var chineseName = this.searchfilter.deptAirport;
      var airportCode = this.searchfilter.deptAirportCode;
      this.dynamicFilter.deptAirport = this.dynamicFilter.arrAirport;
      this.dynamicFilter.deptAirportCode = this.dynamicFilter.arrAirportCode;
      this.dynamicFilter.arrAirport = chineseName;
      this.dynamicFilter.arrAirportCode = airportCode;
    },
    changeFlightsAirports() {
      var chineseName = this.searchfilter.deptAirport;
      var airportCode = this.searchfilter.deptAirportCode;
      this.searchfilter.deptAirport = this.searchfilter.arrAirport;
      this.searchfilter.deptAirportCode = this.searchfilter.arrAirportCode;
      this.searchfilter.arrAirport = chineseName;
      this.searchfilter.arrAirportCode = airportCode;
    },
    beginSlideNews() {
      new Swiper("#news-swiper .swiper-container", {
        direction: "vertical",
        slidesPerView: 2,
        spaceBetween: 0,
        followFinger: false,
        speed: 1000,
        mousewheel: true,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }
      });

      new Swiper("#certify .swiper-container", {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        speed: 800,
        loopedSlides: 3,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination"
          //clickable :true,
        },
        on: {
          progress: function(progress) {
            //console.log("几个：" + this.slides.length);
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var modify = 1;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              var translate = slideProgress * modify * 260 + "px";
              var scale = 1 - Math.abs(slideProgress) / 5;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 1) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          }
        }
      });
    },
    dynamicSearchHandler() {
     // console.log(this.dynamicFilter);
    },
    validateMobileNumber(number) {
      if (number === "") {
        return { message: "请填写联系手机" };
      }
      let re = /^(13[0-9]|147|145|15[0-9]|17[0-9]|18[0-9])[0-9]{8}$/;
      if (!re.test(number)) {
        return { message: "联系手机不合法,请输入正确的手机号！" };
      }
      return undefined;
    },
    checkInHandler() {
      //console.log(this.checkInFilter);
      // certNo:'',tktNo:'',passName:'',passTel:''

      if (this.checkInFilter.certNo.length <= 0 && this.checkInByID) {
        this.$message({
          showClose: true,
          message: "请输入正确的证件号",
          type: "warning"
        });

        this.$refs.certNo.focus();
        return;
      }
      if (this.checkInFilter.tktNo.length <= 0 && this.checkInByTN) {
        this.$message({
          showClose: true,
          message: "请输入正确的票号",
          type: "warning"
        });

        this.$refs.tktNo.focus();
        return;
      }
      if (this.checkInFilter.passName.length <= 0) {
        this.$message({
          showClose: true,
          message: "旅客姓名不能为空，请核实输入",
          type: "warning"
        });

        this.$refs.passName.focus();
        return;
      }
      let validatePhoneResult = this.validateMobileNumber(
        this.checkInFilter.passTel
      );
      if (validatePhoneResult != undefined) {
        this.$message({
          showClose: true,
          message: validatePhoneResult.message,
          type: "warning"
        });

        this.$refs.passTel.focus();
        return;
      }
      if (!this.checkInFilter.checked) {
        this.$message({
          showClose: true,
          message: "请先阅读并同意值机协议",
          type: "warning"
        });

        return;
      }
      this.$router.push({
        path: "/service/checkin",
        query: {
          certNo: this.checkInByTN
            ? this.checkInFilter.tktNo
            : this.checkInFilter.certNo,
          passName: this.checkInFilter.passName,
          passTel: this.checkInFilter.passTel
        }
      });
    },
    changeHot(item) {
     // console.log(item);
      this.activeHotAirport = item;
      this.loadLowestFlights(this.activeHotAirport);
    },
    selectPannel(pannelId) {
      document.getElementById("li_booking").setAttribute("class", "");
      document.getElementById("li_aoc").setAttribute("class", "");
      document.getElementById("li_jjbooking").setAttribute("class", "");
      document.getElementById(pannelId).setAttribute("class", "active");
      if (pannelId == "li_booking" || pannelId == "li_jjbooking") {
        this.bookingtabstatus = true;
        this.dynamictabstatus = false;
        this.checkintabstatus = false;
        if (pannelId == "li_booking") {
          this.normalBooking = true;
        } else {
          this.normalBooking = false;
        }
      } else if (pannelId == "li_aoc") {
        this.bookingtabstatus = false;
        this.dynamictabstatus = true;
        this.checkintabstatus = false;
      }
    },
    changeDynamicTab(tab) {
      if (tab == "AIRPORT") {
        this.dynamictab_airport = true;
        this.dynamictab_flightno = false;
        this.dynamicType = "AIRPORT";
      } else if (tab == "FLIGHTNO") {
        this.dynamictab_airport = false;
        this.dynamictab_flightno = true;
        this.dynamicType = "FLIGHTNO";
      }
      this.dynamicFilter.dynamicType = this.dynamicType;
    },
    changeTab(lab) {
      if (lab == "OW") {
        this.tripType = "OW";
      } else if (lab == "RT") {
        this.tripType = "RT";
      }
    },
    changeCheckInTab(tab) {
      if (tab == "ID") {
        this.checkInByID = true;
        this.checkInByTN = false;
      } else if (tab == "TN") {
        this.checkInByID = false;
        this.checkInByTN = true;
      }

      this.checkInType = tab;
      this.checkInFilter.checkinType = tab;
    },
    gotoHotline: function(hotItem) {
      this.$router.push({
        path: "/ticket",
        query: {
          deptAirportCode: hotItem.depAirportCode,
          arrAirportCode: hotItem.arrAirportCode,
          deptDate: hotItem.flightDate
        }
      });
    },
    loadHotAirlines() {
      var req = {};
      var that = this;
      // var req={t:{depAirportCode:this.activeHotAirport.airportCode}};
      getHotAirlines(req).then(res => {
        if (res.success) {
          that.hotAirports = res.data.hotAirports;
          that.hotAirlines = res.data.hotAirlines;
          if (that.hotAirports.length > 0) {
            that.activeHotAirport = that.hotAirports[0];
            this.loadLowestFlights(this.activeHotAirport);
          }
        }
      });
    },
    loadLowestFlights(airportItem) {
      var req = { t: this.hotAirlines[airportItem.airportCode] };
     // console.log(req);
      // var req={t:{depAirportCode:this.activeHotAirport.airportCode}};
      getLowestFlights(req).then(res => {
        if (res.success) {
          this.lowestFlightsData = res.data;
        }
      });
    },
    loadNews: function() {
      var that = this;
      getNewsTopN({ aliasCode: "TCAT_NEWS", topN: 5 }).then(res => {
        if (res.success) {
          this.newsitems = res.data;
          this.newsitems.forEach(item => {
            if (item.coverPic) {
              // that.newsCoverPics.push(item);
            }
          });
          let self = this;
          setTimeout(() => {
            self.beginSlideNews();
          }, 1000);
        }
      });

      getNewsPicTopN({ aliasCode: "TCAT_NEWS", topN: 3 }).then(res => {
        if (res.success) {
          this.newsCoverPics = res.data;
          let self = this;
          setTimeout(() => {
            self.beginSlideNews();
          }, 1000);
        }
      });

      getNewsTopN({ aliasCode: "TCAT_TRAVEL_PRODUCT", topN: 4 }).then(res => {
        if (res.success) {
          this.travelProducts = res.data;
        }
      });
    },
    loadBanner: function() {
      // getAdList({ t: { adPosition: "PC_AD_HOME_TOP_BANNER" } }).then(res => {
      //   if (res.success) {
      //     this.bannerList = res.data;
      //   }
      // });

      //  getAdList({ t: { adPosition: "PC_AD_HOME_NEWS_PIC" } }).then(res => {
      //   if (res.success) {
      //     this.newsPicList = res.data;
      //   }
      // });
      // 更换icon 图片管理获取
      // 首页banner
			this.getAdListByManage();
      // this.getNewsByManage();
    },
    getAdListByManage(){
      let params = {
					columnAliasCode: 'PC-BANNER',
					channelUserId: 'PC'
				}
         getAdListByManage({ t: params }).then(res => {
            if (res.success) {
              this.bannerList = res.data.data;
              this.getBigHeight(res.data.data);
            }
          });
    },
    getNewsByManage(){
      let params = {
					columnAliasCode: 'PC-NEWS',
					channelUserId: 'PC'
				}
         getAdListByManage({ t: params }).then(res => {
            if (res.success) {
              this.newsPicList = res.data.data;
            }
          });
    },
    getAirports: function() {
      return fetchAirports();
    },
    handleChange(type, event) {
     // console.log("输入框变化");
    },
    querySearch(queryString, cb) {
      /* 新增选择机场组件 */
     // console.log("输入:" + queryString + " " + this.searchfilter.deptAirport);
      if (!queryString || queryString.length <= 0) {
        cb([]);
        this.$refs.deptAirportPannel.show();
        this.$refs.arrAirportPannel.close();
        this.defaultAirport = {};
        this.handleSearchOnblur(
          this.searchfilter,
          this.$refs.deptAirportPannel,
          "arr",
          null
        );
        return;
      }
      this.$refs.deptAirportPannel.close();
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // console.log(results);
      if (results != null && results.length > 0) {
        this.defaultAirport = results[0];
        //console.log("first:" + this.defaultAirport.cityName);
      }

      cb(results);
    },
    querySearch2(queryString, cb) {
      //console.log("输入:" + queryString);
      if (!queryString || queryString.length <= 0) {
        cb([]);
        this.$refs.arrAirportPannel.show();
        this.$refs.deptAirportPannel.close();
        this.defaultAirport = {};
        this.handleSearchOnblur(
          this.searchfilter,
          this.$refs.arrAirportPannel,
          "arr",
          null
        );
        return;
      }
      this.$refs.arrAirportPannel.close();
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      //console.log(results);
      if (results != null && results.length > 0) {
        this.defaultAirport = results[0];
      }

      cb(results);
    },
    handleSearchOnblur(target, pannel, type, event) {
      var that = this;
      var filterResult = [];
      if (type == "dept") {
        if (target.deptAirport) {
          filterResult = this.restaurants.filter(
            this.createFilter(target.deptAirport)
          );
        }
      } else {
        if (target.arrAirport) {
          filterResult = this.restaurants.filter(
            this.createFilter(target.arrAirport)
          );
        }
      }

      if (filterResult && filterResult.length > 0) {
        this.defaultAirport = filterResult[0];
      } else {
        that.defaultAirport = {};
      }
     // console.log(that.defaultAirport);
      if (type == "dept") {
        target.deptAirport = that.defaultAirport.cityName? that.defaultAirport.cityName          : "";
        target.deptAirportCode = that.defaultAirport.airportCode          ? that.defaultAirport.airportCode          : "";
        if (event != null && target.deptAirport) {
           pannel.close();
        }
      } else {
        target.arrAirport = that.defaultAirport.cityName          ? that.defaultAirport.cityName          : "";
        target.arrAirportCode = that.defaultAirport.airportCode          ? that.defaultAirport.airportCode          : "";
        if (event != null && target.arrAirport) {
          //
          //
           pannel.close();
        }
      }
    },
    querySearchDynamic(queryString, cb) {
      /* 新增选择机场组件 */
      if (!queryString || queryString.length <= 0) {
        cb([]);
        this.$refs.deptAirportPannelDynamic.show();
        this.$refs.arrAirportPannelDynamic.close();
        this.defaultAirport = {};
        this.handleSearchOnblur(
          this.dynamicFilter,
          this.$refs.deptAirportPannelDynamic,
          "dept",
          null
        );
        return;
      }
      this.$refs.deptAirportPannelDynamic.close();
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      //   console.log(results);

      if (results != null && results.length > 0) {
        this.defaultAirport = results[0];
      }

      cb(results);
    },
    querySearchDynamic2(queryString, cb) {
      /* 新增选择机场组件 */
      if (!queryString || queryString.length <= 0) {
        cb([]);
        this.$refs.arrAirportPannelDynamic.show();
        this.$refs.deptAirportPannelDynamic.close();
        this.defaultAirport = {};
        this.handleSearchOnblur(
          this.dynamicFilter,
          this.$refs.arrAirportPannelDynamic,
          "arr",
          null
        );
        return;
      }
      this.$refs.arrAirportPannelDynamic.close();
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;

      if (results != null && results.length > 0) {
        this.defaultAirport = results[0];
      }
      //   console.log(results);
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.chineseName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) >= 0 ||
          restaurant.cityName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) >= 0 ||
          (restaurant.pinYin &&
            restaurant.pinYin
              .toLowerCase()
              .indexOf(queryString.toLowerCase()) >= 0) ||
          restaurant.airportCode
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) >= 0
        );
      };
    },
    handleSelect(type, item) {
      if (type == "dept") {
        this.searchfilter.deptAirport = item.cityName;
        this.searchfilter.deptAirportCode = item.airportCode;
      } else {
        this.searchfilter.arrAirport = item.cityName;
        this.searchfilter.arrAirportCode = item.airportCode;
      }
      //  console.log(item);

      this.defaultAirport = item;
    },
    handleSelectDynamic(type, item) {
      if (type == "dept") {
        this.dynamicFilter.deptAirport = item.cityName;
        this.dynamicFilter.deptAirportCode = item.airportCode;
      } else {
        this.dynamicFilter.arrAirport = item.cityName;
        this.dynamicFilter.arrAirportCode = item.airportCode;
      }

      this.defaultAirport = item;
    },
    gotoSearchFlgihts() {
      // console.log(this.searchfilter);
      if (
        this.searchfilter.deptAirport === "" ||
        this.searchfilter.arrAirport === ""
      ) {
        this.$message({
          showClose: true,
          message: "请选择完整的出发到达城市",
          type: "warning"
        });
        return;
      }
      this.$router.push({
        path: "/ticket",
        query: {
          deptAirportCode: this.searchfilter.deptAirportCode,
          arrAirportCode: this.searchfilter.arrAirportCode,
          deptDate: this.searchfilter.deptDate,
          retDate: this.searchfilter.retDate,
          switch: this.searchfilter.tripType,
          normalBooking: this.normalBooking
        }
      });
    },
    gotoSearchDynamic() {
      if (
        this.dynamicFilter.deptAirport === "" ||
        this.dynamicFilter.arrAirport === ""
      ) {
        this.$message({
          showClose: true,
          message: "请选择完整的出发到达城市",
          type: "warning"
        });
        return;
      }
      this.$router.push({
        path: "/service/aoc",
        query: {
          deptAirportCode: this.dynamicFilter.deptAirportCode,
          arrAirportCode: this.dynamicFilter.arrAirportCode,
          deptDate: this.dynamicFilter.deptDate,
          flightNo: this.dynamicFilter.flightNo,
          dynamicType: this.dynamicFilter.dynamicType
        }
      });
    },
    changePassNum(val) {
      this.searchfilter.passADT = val.adtNum;
      this.searchfilter.passCHD = val.chNum;
      //console.log(this.searchfilter);
    },
    getImgWH(img_url){
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.src = img_url;
            img.onload = function(){
                let imgInfo = {
                  width: img.width,
                  height:  img.height
                }
                resolve(imgInfo);
            }
      })
    },
    async getBigHeight(data){
        let heightArr = [];
        for (let value of data.values()) {
            let info = await this.getImgWH(value.iconUrl)
            let h = info.height
            heightArr.push(h)
        }
        this.imgHeight = Math.max(...heightArr) // 取最大高度
    },

     _queryOrderNeedKnowDictKeys() {
        queryNoticeList({ key: "SELF_CHECK_IN_NOTICE_ALIAS_PC" }).then((res) => {
          if (res.success) {
            this.orderNeedKnows = JSON.parse(res.data)
          }
        });
      },

    // 获取配置的默认OD
    async getDicConfigByKey(key) {
      try {
        const res = await queryDict({key});
        if (res && res.success) {
          const result = res.data ? JSON.parse(res.data) : null;
          const obj = {
            deptAirport: result?.dept?.cityName || '长沙',
            deptAirportCode: result?.dept?.airportCode || 'CSX',
            arrAirport: result?.arr?.cityName || '昆明',
            arrAirportCode: result?.arr?.airportCode || 'KMG',
          }
          this.searchfilter = {...this.searchfilter, ...obj}
          // this.dynamicFilter = {...this.dynamicFilter, ...obj}
        }
      } catch (e) {
        console.log(e);
      }
    },

  }
};
</script>
<style>
.el-carousel__arrow--right {
  right: 64px;
}

.el-carousel__arrow--left {
  left: 64px;
}
</style>
<style scoped lang='less'>
dd,
dl,
dt,
li,
ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: block;
}

.swiper-parent {
  color: #6f829c;
  width: 1000px;
  float: left;
  height: 30px;
  overflow: hidden;
}

.block_item_parent {
  margin: auto;
  width: 1200px;
  text-align: center;
  margin-top: 15px;
  margin-bottom: 20px;
  margin-top: 20px;
  height: 32px;
}

.block_item_title {
  float: left;
  padding: 5px;
  color: #333;
  font-weight: 500;
  font-size: 32px;
}

.block_item_en {
  float: left;
  font-size: 20px;
  color: rgb(226, 226, 226);
  margin-left: 20px;
  vertical-align: bottom;
  line-height: 38px;
}

.el-carousel__indicators--horizontal {
  bottom: 38px;
  right: 0;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}

.pic-card {
  position: relative;
  overflow: hidden;
  width: 285px;
  height: 400px;
  display: inline-block;
  vertical-align: middle;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #fff;
  letter-spacing: 0.88px;
  cursor: pointer;
}

.pic-card-right {
  position: relative;
  overflow: hidden;
  width: 400px;
  height: 230px;
  display: inline-block;
  vertical-align: middle;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #fff;
  letter-spacing: 0.88px;
  cursor: pointer;
}

.pic-card:hover,
.pic-card-right:hover {
  -webkit-box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12),
    0 8px 24px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12), 0 8px 24px 0 rgba(0, 0, 0, 0.12);
}

.pic-bt-box {
  position: absolute;
  bottom: 0;
  width: 100%;
  font-size: 18px;
  height: 72px;
  line-height: 72px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
}

.news-block img {
  cursor: pointer;
  transition: all 0.6s;
}

.news-block img:hover {
  transform: scale(1.05);
}

.link-more {
  right: 35px;
  top: 50%;
  display: inline-block;
  margin-top: -10px;
  line-height: 43px;
  vertical-align: middle;
  margin-right: 10px;
  text-decoration: none;
  color: #d60039;
  font-size: 12px;
  text-decoration: none;
}

.indexbtn {
  width: 100px;
  /* margin-top: 20px; */
  border-radius: 5px;
  position: absolute;
  right: 30px;
  height: 100px;
  bottom: 20px;
}

.bottomnotify {
  width: 400px;
}

.banner {
  position: relative;
  overflow: hidden;
  // height: 550px;
  // margin-top: 1px;
  background-color: #fff;
}

.banner-li {
  position: absolute;
  width:100%;
}

.index-notice {
  position: absolute;
  width: 100%;
  top: 12px;
  height: 45px;
  margin-top: 60px;
  z-index: 99;
  line-height: 45px;
  background-color: #d7003606;
  transition: top 200ms;
  // opacity: 0.5;
  // z-index: 1000;
}

.notice-scroll {
  width: 1200px;
  margin: auto;
  padding: 2px;
  /* display: flex; */
}
.notice-title {
  float: left;
  display: flex;
  /* background: #D70039; */
  color: #ffffff;
  height: 36px;
  line-height: 36px;

  padding: 2px;
  svg {
    margin-right: 9px;
  }
}
.notice-title p {
  background: #d70039;
}

.search-block {
  width: 1200px;
  height: 40px;
  margin: auto;
  position: relative;
}

.popcontext .tab {
  position: absolute;
  left: 0px;
  top: -150px;
  z-index: 1000;
  background: #fff;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  border-radius: 10px;
  padding: 5px;
}
.hggroup-svg {
  padding-top: 5px;
  margin-right: 9px;
}
.popcontext .tab li {
  width: 150px;
  display: flex;
  align-items: center;
  justify-items: center;
  color: #d60039;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  /* margin-left: 10px; */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: 10px;
  padding-left: 10px;
}
.popcontext .tab li .svg-suf {
  height: 34px;
  line-height: 34px;
  margin-left: -1px;
}
.popcontext .tab li .svg-suf svg {
  fill: transparent !important;
}

.popcontext .tab li.active div {
  /* background-color: #fff; */
  background: #d60039;
  color: #ffffff;
  -moz-opacity: 1;
  opacity: 1;
}
.popcontext .tab li.active .svg-suf svg {
  fill: #d60039 !important;
}
.pannel-body {
  display: flex;
  height: 90px;
  & > div {
    width: 40%;
  }
}
.popcontext hgroup {
  display: none;
  position: absolute;
  width: 1200px;
  top: -75px;
  left: 0px;
  z-index: 1000;
  background-color: #ffffff;
  -webkit-border-radius: 0 5px 5px 0;
  -moz-border-radius: 0 5px 5px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}

.popcontext hgroup article {
  position: relative;
  /* height: 364px; */
  padding-left: 10px;
  border-radius: 10px;
}

.recommend {
  margin-top: 20px;
}
.main-title {
  padding: 5px;
  color: #333;
  font-weight: 500;
  font-size: 32px;
  text-align: left;
}
.sub-title {
  padding: 0 0 5px 5px;
  color: #333;
  font-weight: 500;
  font-size: 24px;
  margin: 0 0 20px 0;
  text-align: left;
}
.discount-city {
  /* margin-left: 130px; */
  /* float: right; */
}

.discount-city li {
  display: inline-block;
  width: 60px;
  margin-left: 7px;
  padding: 5px 5px 7px 5px;
  background: #fdfdfd;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  border-radius: 5px;
}

.discount-city li.active {
  background: #d60039;
  color: #ffffff;
  font-size: 14px;
}

.news-block-header {
  padding-top: 10px;
  border-bottom: 1px solid #ededed;
  height: 40px;
  line-height: 30px;
}

.news-block-title {
  position: relative;
  float: left;
  padding: 0;
  height: 44px;
  font-size: 18px;
  font-weight: 600;
  line-height: 44px;
  color: #4d4e4e;
  text-align: left;
  padding: 0 4px;
}

.news-block-title::after {
  position: absolute;
  right: 0;
  bottom: 2px;
  left: 0;
  display: block;
  height: 2px;
  content: "";
  background-color: #ceb6bc;
}

.news-block-more {
  float: right;
  margin: 13.5px 8px 0 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  color: #9d9d9d;
  text-align: left;
  cursor: pointer;
  -webkit-transition: color, 0.3s;
  transition: color, 0.3s;
}

.news-block-body ul {
  min-height: 300px;
  margin-top: 10px;
  padding: 1px 12px 2px 2px;
  /* background-color: #fafafa;
  border: 1px solid #f5f5f5; */
  border-radius: 2px;
}

.news-block-body ul li {
  /* border-bottom: 1px dotted #ededed; */
}

.news-block-body ul li a {
  display: block;
  padding: 8px 2px;
}
.news-block-body ul li:hover {
  background-color: rgba(236, 233, 233, 0.5);
  color: #fff;
  cursor: pointer;
  //   opacity: 0.5;
}

.news-block-body ul li:last-child {
  border-bottom: none;
}

.news-block-body ul li a span:first-child {
  float: left;
  min-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.news-block-body .clearfix {
  display: block;
  height: 0;
  content: "";
  clear: both;
  visibility: hidden;
  overflow: hidden;
}

.commendlist {
  /* margin-left: 20px; */
}

.commendlist ul li {
  float: left;
  background-color: #ffffff;
  position: relative;
}
.commendlist ul li:not(:first-child) {
  margin-left: calc(80px / 3);
}
.commendlist ul li:hover a {
  background-color: #f7f7f7;
}
.commendlist ul li:hover .commend-item-bottom {
  background-color: #f7f7f7;
}

.commendlist ul li a {
  width: 240px;
  height: 150px;
  display: block;
  padding: 25px 18px;
  color: #adadad;
  background: rgb(253 240 243);
  border-radius: 10px;
}
.commend-item-bottom {
  position: absolute;
  top: 200px;
  left: 0;
  width: 280px;
  height: 32px;
  background: rgb(253 240 243);
  transform: skewY(3deg) translateY(-15px);
  border-radius: 12px 0 12px 12px;
  z-index: 1;
}

.commendlist ul li a dl {
  margin-bottom: 10px;
  height: 27px;
  line-height: 33px;
}

.commendlist ul li a dd {
  min-width: 40px;
  max-width: 110px;
  float: left;
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #333;
}

.commendlist ul li a dd.center {
  min-width: 33px;
  max-width: 33px;
  margin: 0 6px;
}

.commendlist ul li a dd {
  min-width: 40px;
  max-width: 110px;
  float: left;
  font-size: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #333;
}

.commendlist ul li a em div {
  display: inline;
}

.commendlist ul li a em {
  /* position: absolute; */
  right: 20px;
  top: 40px;
  color: #333;
}

.commendlist ul li a em .e2 {
  font-size: 30px;
  color: #cb1d36;
}

.commendlist ul li a dd.center .flight-to {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 18px;
  margin-top: 5px;
  padding: 0;
  vertical-align: middle;
  background: url("../../assets/map-mark-right.png") no-repeat;
}
.to-address {
  font-size: 30px !important;
  font-weight: 500px !important;
}

.panel-header {
  /* border-bottom: 2px solid #e9e8e8; */
  margin-top: 5px;
}

.panel-header .panel-tabs {
  display: block;
  width: 100%;
  height: 42px;
  margin: 0;
  padding: 0;
}

.panel-tabs li {
  width: 50%;
  position: relative;
  float: left;
}

.panel-tabs li a {
  position: relative;
  display: block;
  margin: auto;
  width: 80px;
  height: 42px;
  font-size: 16px;
  font-weight: 600;
  line-height: 42px;

  text-align: center;
  cursor: pointer;
}

.panel-tabs .clearfix:after {
  display: block;
  height: 0;
  content: "";
  clear: both;
  overflow: hidden;
}

.filter {
  /* width: 100%; */
  float: left;
}

.filter .el-input {
  margin-top: 10px;
}

.el-date-editor .el-input {
  width: 100%;
}

.filter-title {
  margin-top: 8px;
  font-size: 14px;
  color: #333;
  padding-left: 13px;
  /* font-weight: 700; */
}
.filter-line {
  width: 2px !important;
  height: 80%;
  margin: 0 20px;
  background: #f5f4f4;
}

.filter-input {
  position: relative;
}

.filter-panel {
  background-color: #ffffff;
  position: absolute;
  top: 68px;
  left: 0;
  border-radius: 10px;
  width: 424px;
  padding: 8px 16px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}

.filter-panel-title {
  color: #9d9d9d;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-select-dropdown__item {
  padding-left: 15px;
}

.separet {
  height: 8px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  margin: 0 12px;
  color: #cb1d36;
  font-weight: bolder;
  margin-top: 55px;
  cursor: pointer;
}

.search-btn {
  width: 90px;
  height: 40px;
  margin-top: 20px;
  margin-left: auto;
  background-color: #d60039;
  color: #ffffff;
  border: 0;
  font-size: 16px;
  font-weight: 700;
}

.panel-tabs li.active:after {
  position: absolute;
  right: 0;
  bottom: -2px;
  left: 0;
  display: block;
  width: 100%;
  height: 2px;
  content: "";
  background-color: #ce212e;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
.el-carousel__item{
  background-color: #fff;
}
.service-wrapper {
  position: relative;
  // z-index: -1;
  overflow: hidden;
  width: 100%;
  // height: 100%;
}
.service {
  height: 600px;
  margin-top: 60px;
  padding-top: 40px;
  background-image: url("../../assets/prod-new.png");
  background-size: 100% 100%;
  // position: absolute;
  /* position: absolute;
    left: 50%;
    margin-left: -960px;
    width: 1920px; */
}
.service .main-title,
.service .main-tip {
  color: #ffffff;
  width: 100%;
  text-align: center;
}
.service .main-title {
  margin-top: 20px;
  font-size: 30px;
}
.service .main-tip {
  font-size: 24px;
  margin-top: 20px;
}
.service .main-item {
  display: flex;
  width: 600px;
  height: 350px;
  margin: 10px auto;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  img {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }
}
.service .main-item div {
  width: 45%;
  height: 45%;
  background: #d60039;
  border-radius: 20px;
  color: #ffffff;
  display: flex;
  font-weight: 500;
  font-size: 30px;
  align-items: center;
  justify-content: center;
}
.product {
  margin-top: 60px;
  height: 570px;
  width: 100%;
}
.product-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.product .product-item {
  width: 280px;
  height: 400px;
  overflow: hidden;
  background: url("https://res.redair.cn/image/20210205201209/product-2.jpg");
  background-size: 100% 100%;
  border-radius: 10px;
  margin-left: 10px;
  position: relative;
  img {
    transition: all 2s;
    width: 280px;
    height: 400px;
    border-radius: 10px;
  }
  cursor: pointer;
  img:hover {
    transform: scale(1.2);
    -webkit-box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12),
      0 8px 24px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12), 0 8px 24px 0 rgba(0, 0, 0, 0.12);
  }
}

.product .product-item .info {
  position: absolute;
  bottom: 40px;
  color: #ffffff;
  line-height: 20px;
  margin-left: 20px;
}
.news-date {
  color: #d8d2d2;
}
.home-container {
  width: 100% !important;
  background: #ffffff !important;
  .container-module {
    width: 1200px;
    margin: 0 auto;
    margin-top: 90px;
  }
  // .search-block{
  //   margin-top: 100px;
  // }
}
.link-sm {
  text-decoration: underline;
  display: block;
}

#certify {
  position: relative;
  width: 700px;
  margin: 0 auto;
}

#certify .swiper-container {
  padding-bottom: 60px;
}

#certify .swiper-slide {
  width: 400px;
  height: 240px;
  background: #fff;

  box-shadow: 0 8px 30px #ddd;
}
#certify .swiper-slide img {
  border-radius: 10px;
  display: block;
}
#certify .swiper-pagination {
  width: 100%;
  bottom: 20px;
}

#certify .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 5px;
  border: 3px solid #fff;
  background-color: #d5d5d5;
  width: 10px;
  height: 10px;
  opacity: 1;
}

#certify .swiper-pagination-bullets .swiper-pagination-bullet-active {
  border: 3px solid #00aadc;
  background-color: #fff;
}

#certify .swiper-button-prev {
  left: -30px;
  width: 45px;
  height: 45px;
  //background: url(../images/wm_button_icon.png) no-repeat;
  background-position: 0 0;
  background-size: 100%;
}

#certify .swiper-button-prev:hover {
  background-position: 0 -46px;
  background-size: 100%;
}

#certify .swiper-button-next {
  right: -30px;
  width: 45px;
  height: 45px;
  // background: url(../images/wm_button_icon.png) no-repeat;
  background-position: 0 -93px;
  background-size: 100%;
}

#certify .swiper-button-next:hover {
  background-position: 0 -139px;
  background-size: 100%;
}
</style>
